// © Microsoft Corporation. All rights reserved.

import { OneTrustCookieCategory } from "../cookie-enums";

export const OneTrustCookieCategorization: { [key in OneTrustCookieCategory]: Array<string> } = {
    [OneTrustCookieCategory.C0001]: [
        "ANON",
        "ANONCKNM",
        "APP_ANON",
        "BFB",
        "BFBUSR",
        "DefaultLocation",
        "Edgecac",
        "FreWv",
        "GalleryMode",
        "MC1",
        "MS0",
        "MSCC",
        "MSFPC",
        "MSNRPSAuth",
        "MSNRPSSecAuth",
        "MSPRequ",
        "MUID",
        "MUIDB",
        "MicrosoftApplicationsTelemetryDeviceId",
        "OptanonAlertBoxClosed",
        "OptanonConsent",
        "OvrlyTrf",
        "PreferencesMsn",
        "RUM",
        "RecentStocks",
        "SRCHD",
        "SRCHHPGUSR",
        "SRCHUID",
        "SRCHUSR",
        "Sample",
        "TOptOut",
        "UMH2E",
        "WLMMAC",
        "_EDGE_S",
        "_EDGE_V",
        "_SS",
        "_U",
        "_cb",
        "_cb_ls",
        "_cb_svref",
        "aace",
        "ace",
        "ahs-dismissed",
        "ahs-installed",
        "ahs-showings",
        "ai_session",
        "at",
        "at-bing",
        "bcookie",
        "bingimage",
        "bwssoc",
        "cac",
        "cb",
        "cbypass",
        "cfrecnt",
        "child",
        "cmdisp",
        "cmwr",
        "ddlcur",
        "df",
        "ecasession",
        "eub",
        "eupubconsent",
        "eupubconsent-v2",
        "gfrecnt",
        "hidebn",
        "i18next",
        "ipt",
        "ipv6",
        "isdomainmigrated",
        "lt",
        "marketPref",
        "mktreset",
        "mniotd",
        "mnmarket",
        "msaOptout",
        "msaoptout",
        "nactk",
        "no_read_more",
        "ntps",
        "numac",
        "orfc_feeds",
        "pbmi",
        "pglt-edgeChromium-dhp",
        "pglt-edgeChromium-ntp",
        "pglt-microsoftNews-msnews",
        "pglt-microsoftNews-startpage",
        "pop",
        "refresh-reason",
        "sbc-dismissed",
        "sbc-installed",
        "sbc-showings",
        "smd",
        "sptmarket",
        "timeZoneOffsetInMins",
        "uaid",
        "videoCookiesLastCategory",
        "videoerrorcount",
        "w10rp",
        "w10rpls",
        "weaDetectLocation",
        "weaPeregrineDegreeType",
        "weaPeregrineDetectLocation",
        "weaPeregrineFavoriteLocations",
        "weaPeregrineHomeLocation",
        "weaPeregrineHomeLocationBackup",
        "weaPeregrineRecentLocations",
        "weaSpartanDegreeType",
        "weaSpartanFavoriteLocations",
        "weaSpartanHomeLocation",
        "weaSpartanRecentLocations"
    ],
    [OneTrustCookieCategory.C0002]: [
        "BizoID",
        "dub_downlevel",
        "eAPID",
        "ecadprovider",
        "ecisession",
        "ecmsession",
        "ecsession"
    ],
    [OneTrustCookieCategory.C0003]: [
        "promptDisplayCount"
    ],
    [OneTrustCookieCategory.C0004]: []
};